import { render, staticRenderFns } from "./totalMsg.vue?vue&type=template&id=0236381c&scoped=true"
import script from "./totalMsg.vue?vue&type=script&lang=js"
export * from "./totalMsg.vue?vue&type=script&lang=js"
import style0 from "./totalMsg.vue?vue&type=style&index=0&id=0236381c&prod&rel=stylesheet%2Fscss&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0236381c",
  null
  
)

export default component.exports